
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexTl8P9PLI6zCyHeO62Z0iDe7f2WhhFGnDrUt0MGAUMfQMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/index.vue?macro=true";
import { default as _91id_93xEN2Kav0gdF78nwI_45WyFKApnkJzr7FO8_vK3Bdf5Or0Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/form/[id].vue?macro=true";
import { default as _91id_93zaiJYraUCHicZHoOXbn50j0toAmCpfSxnTZ8zWhojpwMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/media/[id].vue?macro=true";
import { default as indexujzZNBlSbH4GFAOAEXyW3beduOL8uW3VKTVmbC5pr8MMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/start/index.vue?macro=true";
import { default as index40oSpB22oXvWyyudwn92hCX2uD0K5V1Rth__45AEwTEkoMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/search/index.vue?macro=true";
import { default as indexDOMcGATMJXEWqHsotByJmo_45NcanD4IDv2cDWhC5ILpEMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/article/index.vue?macro=true";
import { default as index6tiMzD_45p_MbZo5fQDv77FM0YJFJssp4c4RFs0_NAR_MMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/benefit/index.vue?macro=true";
import { default as indexGkLOQ0iDWTV8esHeV39iFNVSQh68vm4SEmclHKaVGpEMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/benefits/index.vue?macro=true";
import { default as index3_YLQLVMsFcYXAt40KxbEt0IDxmXPHmRVBEiGAw5eooMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/magazine/index.vue?macro=true";
import { default as index6ClDWZ1k0dz_4566_G8QJUanm2QlceZMLDdYVwsDDmb4MMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/[...slug]/index.vue?macro=true";
import { default as indexRqRCMVvlWsV2t6bZbegF79WfXibMyrCaXIHd5HHaxWgMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/[id]/index.vue?macro=true";
import { default as indexpjaI77zVdtR6wYLzl5eoEqazEKKY7rjrbTl67fdyEK8Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/node/[nid]/index.vue?macro=true";
import { default as indexseuM9CLVxexophOunpCH51k1J9ohzJkyIRHRAfUMD_4Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/login/index.vue?macro=true";
import { default as indexLTquhXl9Lioe8AyXFgFdMAocOPkqiytBHsjgX3Q1K78Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/reset/index.vue?macro=true";
import { default as indexmLt_zd3eaaVQd48bkHITj_5Zsf55ArV3mu73SRWfpu0Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/register/index.vue?macro=true";
import { default as indexQyDdrHGBmaupsVAKHIu7whKG9R5Q0JYlpuVjVVMCXqgMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/benefitsOverview/index.vue?macro=true";
import { default as _91id_93S_TYgjQdG1ySH1S6saRhNl5qvk0K_45ijBrEhSNExaw24Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/form/confirmation/[id].vue?macro=true";
import { default as indexaChOn9JGUFWGKvz5XBcqHg0OWxpioJhfRyavpOXt3KcMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/magazineOverview/index.vue?macro=true";
import { default as indexhexILlwXKg3dYbPaM7VaaRKOvCtfjleUxB2jk2wdrU4Meta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/checkout/validate/index.vue?macro=true";
import { default as _91_91login_93_93BiIT_21hGzDG2Erj1GNOwAjbZ3FtaK7aAqLY4p62BFoMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/reset/[id]/[timestamp]/[hash]/[[login]].vue?macro=true";
import { default as component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXIMeta } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXI } from "/home/portal/domains/stage.famillesuisse.ch/www/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "home",
    path: "/",
    meta: indexTl8P9PLI6zCyHeO62Z0iDe7f2WhhFGnDrUt0MGAUMfQMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/index.vue")
  },
  {
    name: "webform-route",
    path: "/form/:id()",
    meta: _91id_93xEN2Kav0gdF78nwI_45WyFKApnkJzr7FO8_vK3Bdf5Or0Meta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/form/[id].vue")
  },
  {
    name: "media-id",
    path: "/media/:id()",
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/media/[id].vue")
  },
  {
    name: "start",
    path: "/start",
    meta: indexujzZNBlSbH4GFAOAEXyW3beduOL8uW3VKTVmbC5pr8MMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/start/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: index40oSpB22oXvWyyudwn92hCX2uD0K5V1Rth__45AEwTEkoMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/search/index.vue")
  },
  {
    name: "node-article",
    path: "/article",
    meta: indexDOMcGATMJXEWqHsotByJmo_45NcanD4IDv2cDWhC5ILpEMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/article/index.vue")
  },
  {
    name: "node-benefit",
    path: "/benefit",
    meta: index6tiMzD_45p_MbZo5fQDv77FM0YJFJssp4c4RFs0_NAR_MMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/benefit/index.vue")
  },
  {
    name: "taxonomy-benefits",
    path: "/benefits",
    meta: indexGkLOQ0iDWTV8esHeV39iFNVSQh68vm4SEmclHKaVGpEMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/benefits/index.vue")
  },
  {
    name: "taxonomy-categories",
    path: "/magazine",
    meta: index3_YLQLVMsFcYXAt40KxbEt0IDxmXPHmRVBEiGAw5eooMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/magazine/index.vue")
  },
  {
    name: "drupal-route",
    path: "/:slug(.*)*",
    meta: index6ClDWZ1k0dz_4566_G8QJUanm2QlceZMLDdYVwsDDmb4MMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/[...slug]/index.vue")
  },
  {
    name: "user-overview",
    path: "/user/:id()",
    meta: indexRqRCMVvlWsV2t6bZbegF79WfXibMyrCaXIHd5HHaxWgMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/[id]/index.vue")
  },
  {
    name: "node-canonical",
    path: "/node/:nid()",
    meta: indexpjaI77zVdtR6wYLzl5eoEqazEKKY7rjrbTl67fdyEK8Meta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/node/[nid]/index.vue")
  },
  {
    name: "login",
    path: "/user/login",
    meta: indexseuM9CLVxexophOunpCH51k1J9ohzJkyIRHRAfUMD_4Meta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/login/index.vue")
  },
  {
    name: "user-reset",
    path: "/user/reset",
    meta: indexLTquhXl9Lioe8AyXFgFdMAocOPkqiytBHsjgX3Q1K78Meta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/reset/index.vue")
  },
  {
    name: "register",
    path: "/user/register",
    meta: indexmLt_zd3eaaVQd48bkHITj_5Zsf55ArV3mu73SRWfpu0Meta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/register/index.vue")
  },
  {
    name: "benefits-overview",
    path: "/benefitsOverview",
    meta: indexQyDdrHGBmaupsVAKHIu7whKG9R5Q0JYlpuVjVVMCXqgMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/benefitsOverview/index.vue")
  },
  {
    name: "webform-confirmation",
    path: "/form/confirmation/:id()",
    meta: _91id_93S_TYgjQdG1ySH1S6saRhNl5qvk0K_45ijBrEhSNExaw24Meta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/form/confirmation/[id].vue")
  },
  {
    name: "magazine-overview",
    path: "/magazineOverview",
    meta: indexaChOn9JGUFWGKvz5XBcqHg0OWxpioJhfRyavpOXt3KcMeta || {},
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/magazineOverview/index.vue")
  },
  {
    name: "checkout-validate",
    path: "/checkout/validate",
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/checkout/validate/index.vue")
  },
  {
    name: "user-reset-id-timestamp-hash-login",
    path: "/user/reset/:id()/:timestamp()/:hash()/:login?",
    component: () => import("/home/portal/domains/stage.famillesuisse.ch/www/frontend/pages/user/reset/[id]/[timestamp]/[hash]/[[login]].vue")
  },
  {
    name: component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXIMeta?.name,
    path: "/account/register",
    component: component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXI
  },
  {
    name: component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXIMeta?.name,
    path: "/account/login",
    component: component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXI
  },
  {
    name: component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXIMeta?.name,
    path: "/account",
    component: component_45stubDcmadzro8AA0gw14zOJI_45xIgO1E1UfhG3k9WXDTFGXI
  }
]